import { Component } from '@angular/core';

@Component({
  selector: 'rr-gender-male',
  templateUrl: './gender-male.component.html',
  styleUrls: ['./gender-male.component.scss'],
})
export class GenderMaleComponent {
  constructor() {}
}
